import { makeApi } from "@zodios/core";
import { z } from "zod";

import { EGouvSearchAddressType, gouvSearchResultDtoSchema } from "@/api/gouv/search/gouv-address-search.type.ts";

export const gouvAddressSearchApi = makeApi([
  {
    method: "get",
    path: "/",
    response: gouvSearchResultDtoSchema,
    alias: "autocompleteAddress",
    parameters: [
      {
        type: "Query",
        name: "q",
        schema: z.string(),
      },
      {
        type: "Query",
        name: "type",
        schema: z.nativeEnum(EGouvSearchAddressType),
      },
      {
        type: "Query",
        name: "autocomplete",
        schema: z.number().min(0).max(1),
      },
    ],
  },
]);
